// @ts-nocheck
import * as React from 'react';
import * as ReactDom from 'react-dom';

import AegisLayout from 'aegisv2/Layout';

import { transformInitialStateTranslations } from '@crehana/i18n';

import Layout from 'Shared/LayoutV2';

import loadThirdParty from 'Jsx/Utils/thirdPartyLoader/loadThirdParty';

import App from './containers/App';
import { getInitialState } from './helpers';

import { RESOURCE_DETAIL_PAGE_KEY } from './constants';
import localeEs from './i18n/localeEs';
import localePt from './i18n/localePt';

const initialState = getInitialState(
  window.__INITIAL_STATE__,
  null,
  window.__INITIAL_STATE__,
);

ReactDom.render(
  <Layout
    // Handled manually
    userActivityPageView={null}
    pageKey={RESOURCE_DETAIL_PAGE_KEY}
    crehanaI18n={{
      languageCode: window.__INITIAL_STATE__.LANGUAGE_KEY,
      translations: transformInitialStateTranslations(
        window.__INITIAL_STATE__.translation_keys,
      ),
      defaultNs: RESOURCE_DETAIL_PAGE_KEY,
      defaultTranslations: {
        ...localeEs,
        ...localePt,
      },
      fallbackNs: ['main-menu'],
    }}
  >
    <AegisLayout>
      <App {...initialState} />
    </AegisLayout>
  </Layout>,
  document.getElementById('mainNode') as HTMLElement,
  () => {
    window.addEventListener('DOMContentLoaded', () => {
      loadThirdParty();
    });
  },
);
